import { featureFlag } from "./featureFlags";

export type FeatureFlags =
  | "FEATURE_FLAG_DISCORD_GIVEAWAY_0123"
  | "SEGMENT"
  | "HARDCODE_HAMILTON_HOLDINGS"
  | "CASH_HOLDINGS_ENABLE"
  | "FEATURE_FLAG_APRIME_PRICING_GRAPH";

export const FLAGS = {
  get isECFEnabled() {
    return featureFlag("ecf");
  },
};

/**
 * High-level pages protected by feature flags.
 * Do NOT put essential investor surfaces here (/kyc, /portfolio) —
 * those are gated by auth / accreditation middleware instead.
 * ECF still controls ECF-specific UI via FLAGS.isECFEnabled.
 *
 * /kyc/verify is the iDenfy landing only. Pin longer /kyc/verify-* prefixes
 * to [true] so longest-prefix match does not send them down with the iDenfy
 * kill-switch (manual form / pending / on-hold must stay reachable).
 * ZACD has ecf:false — gating /kyc|/portfolio on ecf 404s those surfaces.
 */
export const FEATURE_FLAGGED_PAGES: { [key: string]: boolean[] } = {
  "/kyc/verify": [featureFlag("idenfy")],
  "/kyc/verify-form": [true],
  "/kyc/verify/pending": [true],
  "/kyc/verify/on-hold": [true],
};

/**
 * Whitelist of countries that are allowed to access a feature-flagged page.
 * Only declare the country code here if the page is not allowed for all countries.
 * Dropping a country from /kyc/verify turns that country's eKYC landing off;
 * middleware redirects to the manual form (not 404).
 */
export const COUNTRY_FLAGGED_PAGES: { [key: string]: string[] } = {
  "/kyc/verify": ["SG", "MY"],
};
